export const callStatusOptions = [
  { label: "Completed", value: "completed" },
  { label: "Busy", value: "busy" },
  { label: "No Answer", value: "no-answer" },
  { label: "Failed", value: "failed" },
  { label: "Voicemail", value: "voicemail" },
  { label: "Voicemail Dropped", value: "voicemail-dropped" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Transferred", value: "transferred" },
  { label: "Skipped", value: "skipped" },
];

export const callOutcomeOptions = [
  "Demo Booked",
  "Busy",
  "Connected",
  "Left Live Message",
  "Left Voicemail",
  "No Answer",
  "Wrong Answer",
];

export const callDirectionOptions = ["Inbound", "Outbound"];

export const meetingOutcomeOptions = [
  " Scheduled",
  "Completed",
  "Rescheduled",
  "No Show",
  "Canceled",
];

export const meetingContacts = ["CONTACTS", "USERS", "LEADS", "ASSOCIATED CONTACTS", "ASSOCIATED LEADS"];
